import React from 'react'

export default function TestUserWarning() {
    return (
        <div className="row">
            <div className="col-md-12">
                <div className="alert alert-warning mt-2 p-2" role="alert">
                    <strong className="fs-9-rem">By checking this box, you are creating a test account.</strong>
                    <ul className="password-hints-list">
                        <li>This account is intended for internal use only.</li>
                        <li>Please note that any data uploaded to this account will not be included in global averages.</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
